/**
 * 🏷 **이 자리 이름은 누구 것인가.**
 *
 * ## 왜 따로 있나
 * 두 가지 이유다.
 *
 * ① **같은 물음을 세 곳이 던진다** — 관리자 [🚀 출시 준비], `pnpm check:deploy`,
 *    그리고 지우기 안내. 답이 갈리면 한쪽은 「고아 31개」라 하고 다른 쪽은 조용하다.
 *
 * ② 🔴 **점검 스크립트가 읽을 수 있어야 한다.** 스크립트는 `--experimental-strip-types` 로
 *    타입스크립트를 직접 읽는데, 이때 상대 import 에 확장자가 없으면 못 읽는다.
 *    그래서 이 파일은 **아무것도 import 하지 않는다** — 그 규칙을 여기 적어 둔다.
 *
 * ## 무엇을 막나
 * 책·상품을 지워도 **올린 파일은 남는다**(되살릴 수 있게 일부러 그렇다). 남는 것 자체는
 * 괜찮지만 **모르면** 아무도 못 치우고 용량만 먹는다. 실제로 운영에 31개가 그 상태였다
 * (2026-08-28: 지운 책의 표지 1·본문 10쪽·읽어주기 20).
 */

/**
 * 이 에셋 키가 **어느 책의 것인가** — 책 이름을 못 읽으면 `null`.
 *
 * 🔴 옛 음성 키(`book.audio.<쪽>.<언어>`, 2칸)에는 **책 이름이 없다.** 이걸 책 이름으로
 * 읽으면 멀쩡한 소리를 「없는 책의 것」으로 신고한다 — 운영자는 지우지 말아야 할 것을 지운다.
 * 칸 수로 가른다(새 형식은 `book.audio.<책>.<쪽>.<언어>`, 3칸).
 */
export function bookIdOfAssetKey(key: string): string | null {
  const audio = /^book\.audio\.(.+)$/.exec(key);
  if (audio) {
    const parts = audio[1]!.split(".");
    return parts.length >= 3 ? parts[0]! : null; // 2칸이면 옛 형식 — 책 이름이 없다
  }
  const m = /^book\.(?:page|cover)\.([^.]+)/.exec(key);
  return m ? m[1]! : null;
}

/** 이 자리 이름이 **어느 상품의 것인가** — 상품 사진이 아니면 `null`. */
export function goodsIdOfSlot(slot: string): string | null {
  const m = /^goods\.([a-z0-9_]{1,40})\.\d{1,2}$/.exec(slot);
  return m ? m[1]! : null;
}
